import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getClustersNodeTemplatesQueryKey } from 'hooks/queries/autoscaler/useClustersNodeTemplatesQuery';
import { getSelectionTemplatesQueryKey } from 'hooks/queries/autoscaler/useSelectionTemplatesQuery';
import { getClusterEdgeLocationsQueryKey } from 'hooks/queries/omni/useGetClusterEdgeLocationsQuery';

export const useDeleteSelectionTemplateMutation = (clusterId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (templateName: string) => {
      return apiClient.autoscaler.deleteSelectionTemplate({
        clusterId,
        nodeTemplateName: templateName,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getSelectionTemplatesQueryKey(clusterId),
      });
      queryClient.invalidateQueries({
        queryKey: getClustersNodeTemplatesQueryKey(),
      });
      queryClient.invalidateQueries({
        queryKey: getClusterEdgeLocationsQueryKey({ clusterId }),
      });
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
